/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandOpenSource = createSolidComponent(
  "brand-open-source",
  "IconBrandOpenSource",
  [
    [
      "path",
      {
        d: "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
      }
    ]
  ]
);

export { IconBrandOpenSource as default };
//# sourceMappingURL=IconBrandOpenSource.js.map
